// Archivo: MiTooltipPersonalizado.js
import React from 'react';

// Joyride nos pasa varias props. Las más importantes son:
// step: El objeto del paso actual (el que tiene 'target' y 'content')
// isLastStep: Para saber si es el último paso
// primaryProps: Props para el botón "Next" o "Close"
// skipProps: Props para el botón "Skip"
// tooltipProps: Props para ponerle al div principal

const MiTooltipPersonalizado = ({
  step,
  isLastStep,
  primaryProps,
  skipProps,
  tooltipProps
}) => {
  return (
    // Usamos las clases de Tailwind que queramos
    <div
      {...tooltipProps}
      className="bg-white text-gray-800 rounded-lg shadow-xl p-5 w-80" // Estilo base con Tailwind
    >
      {/* El contenido del paso */}
      <div className="text-base font-medium mb-4">
        {step.content}
      </div>

      {/* Contenedor para los botones */}
      <div className="flex justify-between items-center mt-4">
        {/* Botón de Skip (Oculto en el último paso) */}
        {!isLastStep && (
          <button
            {...skipProps}
            className="text-sm text-gray-500 hover:text-gray-700"
          >
            Saltar
          </button>
        )}

        {/* Botón de Next o Close */}
        <button
          {...primaryProps}
          className="px-4 py-2 bg-violet-600 text-white rounded-md hover:bg-violet-700"
        >
          {isLastStep ? 'Terminar' : 'Siguiente'}
        </button>
      </div>
    </div>
  );
};

export default MiTooltipPersonalizado;